<template>
  <div>
    <bfheader></bfheader>
    <div class="main-content mt-2">
      <div class="header">
        <b-alert variant="danger" :show="error != null">{{error}}</b-alert>
      </div>
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <div class="card" data-toggle="list">
              <div>
                <b-list-group>
                  <b-list-group-item class="userGroupHeader">
                    <b-form-select
                      v-model="currentUserGroupId"
                      :options="userGroupOptions"
                      class="mb-3"
                      @change="onChange"
                    >
                      <template slot="first">
                        <option :value="null">-- 測定会を選択 --</option>
                      </template>
                    </b-form-select>
                    <b-btn variant="success" size="sm" @click="onSelect">選択</b-btn>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
            <div class="card" data-toggle="list">
              <div>
               <b-list-group>
                  <b-list-group-item>
                    <b-btn variant="link" v-b-toggle.collapse1><i class="fas fa-tools"></i> 管理</b-btn>
                    <b-collapse id="collapse1" class="mt-2">
                      <b-card data-toggle="list">
                        <div>
                          <b-list-group>
                            <b-list-group-item>
                              <b-btn variant="link" @click="$router.push('/users')">参加者一覧</b-btn>
                            </b-list-group-item>
                            <b-list-group-item>
                              <b-btn variant="link" @click="$router.push('/usergroups')">測定会一覧</b-btn>
                            </b-list-group-item>
                            <b-list-group-item>
                              <b-btn variant="link" @click="$router.push('/users/daily_enquetes')">測定結果一覧</b-btn>
                            </b-list-group-item>
                            <b-list-group-item>
                              <b-btn variant="link" @click="$router.push('/users/felicas')">Felica登録一覧</b-btn>
                            </b-list-group-item>
                            <b-list-group-item>
                              <b-btn variant="link" @click="$router.push('/cognito_users')">ログイン情報</b-btn>
                            </b-list-group-item>
                          </b-list-group>
                        </div>
                      </b-card>
                    </b-collapse>
                  </b-list-group-item>
                </b-list-group>
                <b-list-group>
                  <b-list-group-item>
                    <b-btn variant="link" v-b-modal.mobileUrlModal><i class="fas fa-qrcode"></i> スマホURL表示</b-btn>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <bffooter></bffooter>
    <b-modal id="mobileUrlModal" title="www.thinkss-kenkobus.net" hide-footer>
      <qrcode value="https://www.thinkss-kenkobus.net" :options="{ size: 200 }"></qrcode>
    </b-modal>
  </div>
</template>

<script>
import bfheader from '@/components/BfHeader'
import bffooter from '@/components/BfFooter'
import VueQrcode from '@xkeshi/vue-qrcode'
import { Logger } from 'aws-amplify'

const logger = new Logger('Dashboard')

export default {
  name: 'Dashboard',
  components: {
    bfheader,
    bffooter,
    qrcode: VueQrcode
  },
  data () {
    return {
      loading: false,
      message: null,
      error: null
    }
  },
  computed: {
    userGroups () {
      return this.$store.getters.userGroups
    },
    userGroupOptions () {
      let groups = this.$store.getters.userGroups
      let options = []
      options = groups.map(g => {
        return { value: g.groupId, text: g.name }
      })
      return options
    },
    currentUserGroup () {
      return this.$store.getters.currentUserGroup
    },
    currentUserGroupId: {
      get () {
        let curr = this.$store.getters.currentUserGroup
        return curr && curr.groupId
      },
      set () {}
    }
  },
  mounted () {
    this.loadItems()
  },
  methods: {
    loadItems () {
      if (
        !this.$store.getters.userGroups ||
        this.$store.getters.userGroups.length < 1
      ) {
        this.message = null
        this.error = null
        return new Promise(resolve => {
          setTimeout(() => {
            return this.$store
              .dispatch('fetchUserGroups')
              .then(userGroups => {
                // this.userGroups = userGroups
              })
              .catch(err => {
                logger.error(err)
                this.error = err.message || err
              })
          }, 1000)
        })
      }
    },
    refreshItems () {
      return this.loadItems()
    },
    onSelect () {
      logger.debug('select', this.currentUserGroupId)
      this.onChange(this.currentUserGroupId)
    },
    onChange (newValue) {
      if (!newValue) return
      let userGroup = this.$store.getters.userGroups.find(
        g => g.groupId === newValue
      )
      this.$store.commit('setCurrentUserGroup', { userGroup })
      this.$router.push('/usergroups/' + userGroup.groupId + '/top')
    }
  }
}
</script>

<style scoped>
.box-shadow {
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);
}
.userGroupHeader {
  padding: 0.5rem;
  background-color: #003d82;
  color: #fff;
}
</style>
